import React from 'react'
import { useSiteData } from '../context/SiteDataContext.jsx'
import { Container, Card, SectionHeading, ButtonLink } from '../components/atoms.jsx'
import { GalleryGrid, PageHero, RichContent, SeoManager } from '../components/content.jsx'
import { NotFoundPage } from './NotFoundPage.jsx'

export function GalleryPage() {
  const { getPage, galleries } = useSiteData()
  const page = getPage('galleri')
  const gallery = galleries[0]
  const images = gallery?.images?.map((url) => ({ url, alt: gallery.title })) || []

  if (!page) return <NotFoundPage />

  return (
    <>
      <SeoManager
        title={page?.meta_title || 'Galleri | Helseklinikken'}
        description={page?.meta_description || 'Se vores galleri'}
        image={page?.image?.[0]}
        canonical="https://helselarsen.dk/galleri/"
      />

      <main>
        <section className="border-b border-forest-100 bg-[linear-gradient(180deg,#fbf7f1_0%,#f6efe5_100%)] py-10 lg:py-16">
          <Container>
            <PageHero
              page={page}
              kicker="Galleri"
              description="Se vores galleri"
              actions={[
                { label: 'Kontakt os', href: '/kontakt' },
                { label: 'Se patienthistorier', href: '/patienthistorier', variant: 'secondary' },
              ]}
            />
          </Container>
        </section>

        <section className="py-10 lg:py-16">
          <Container className="space-y-8">
            <Card className="space-y-5">
              <SectionHeading eyebrow="Intro" title={page?.title || 'Galleri'} description={page?.meta_description} />
              <RichContent
                html={page?.content || ''}
                className="space-y-4 text-base leading-8 text-stone-700 [&_h2]:font-serif [&_h2]:text-2xl [&_h2]:text-forest-900"
              />
            </Card>

            <GalleryGrid images={images} title="Klinikgalleri" description="Touch-venlig billedvisning med storvisning ved klik." />

            <Card className="space-y-4">
              <SectionHeading eyebrow="Næste skridt" title="Book en tid" description="Slip dit ubehag, rygsmerter, idrætsskader, hovedpine, stress og meget mere." />
              <div className="flex flex-wrap gap-3">
                <ButtonLink href="/kontakt" variant="primary">Kontakt os</ButtonLink>
                <ButtonLink href="tel:86384117" variant="secondary">Tlf. (+45) 86 38 41 17</ButtonLink>
                <ButtonLink href="tel:23114117" variant="secondary">Mobil (+45) 23 11 41 17</ButtonLink>
              </div>
            </Card>
          </Container>
        </section>
      </main>
    </>
  )
}
